<template>
  <div class="subprogram-additional-doc-input">
    <el-form
      :label-position="labelPosition"
      :label-width="labelWidthForm"
      :model="model"
      :rules="rules"
      class="form"
      ref="form"
      v-if="model"
    >
      <el-row :gutter="10">
        <el-col :lg="18" :md="18" :sm="24">
          <el-form-item
            class="el-form-item--radio"
            :prop="fields.exist.name"
            required
          >
            <span v-text="fields.exist.label" />
            <el-radio-group v-model="model[fields.exist.name]">
              <el-radio :label="true">
                <app-i18n code="common.yes" />
              </el-radio>
              <el-radio :label="false">
                <app-i18n code="common.no" />
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :lg="18" :md="18" :sm="18">
          <p
            v-if="model[fields.exist.name]"
            class="subprogram-additional-doc-input__text"
            v-text="i18n('entities.subprogram.fields.additionalDoc.text')"
          />
        </el-col>
        <el-col :lg="18" :md="18" :sm="18">
          <el-form-item
            v-if="model[fields.exist.name]"
            :prop="fields.text.name"
            :required="fields.text.required"
          >
            <el-input
              type="textarea"
              v-model="model[fields.text.name]"
              :autosize="{ minRows: 4, maxRows: 6}"
              :placeholder="i18n('entities.inscription.placeholders.additionalDocText')"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row
        v-if="model[fields.exist.name]"
        :gutter="20"
      >
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :prop="fields.requiredDocs.name"
            :required="fields.requiredDocs.required"
          >
            <app-docs-upload
              :max="fields.requiredDocs.max"
              :path="fields.requiredDocs.path(pathStore)"
              :placeholder="fields.requiredDocs.label"
              :schema="fields.requiredDocs.fileSchema"
              :requiredDocs.sync="model[fields.requiredDocs.name]"
              ref="uploadDocsForm"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { i18n } from '@shared/i18n'
import { FormSchema } from '@shared/form/form-schema';

import { SubprogramAdditionalDocModel } from '@modules/subprogram/subprogram-additional-doc-model';

const { fields } = SubprogramAdditionalDocModel;
const formSchema = new FormSchema([
  fields.exist,
  fields.text,
  fields.requiredDocs,
]);

export default {
  name: 'subprogram-additional-doc-input',

  props: {
    additionalDoc: Object,

    subpropertyId: {
      type: String,
      required: true,
    },

    programId: {
      type: String,
      required: true,
    },

    subprogramId: {
      type: String,
    },
  },

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
      initialModel: null,
      requiredDocs: [
        {
          title: '',
          file: {},
        },
      ],
      i18n,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
    }),

    fields() {
      return fields;
    },

    pathStore() {
      return {
        subpropertyId: this.subpropertyId,
        programId: this.programId,
        subprogramId: this.subprogramId
      };
    },
  },

  async created() {
    this.initialModel = Object.assign(
      {},
      this.additionalDoc,
    );
    this.model = formSchema.initialValues(
      this.additionalDoc,
    );
  },

  watch: {
    model: {
      deep: true,
      handler(val) {
        this.$emit('update:additionalDoc', val);
      },
    },
  },
};
</script>


<style scoped>
.subprogram-additional-doc-input .el-form {
  padding: 0 0 30px;
}
.subprogram-additional-doc-input__text {
  font-size: 14px;
  font-weight: normal;
  letter-spacing: -0.3px;
  margin-top: 8px;
}
</style>
